const tableData = [
    {
        num: '1',
        warehouse: '樱花仓',
        quoteItem: '',
        priceUnit: '',
        flowRate: '',
        remark: '',
        formula: '',
        volume: '3632793.91',
        totalPrice: '',
        price: '',
        showSubTable: true,
        checked: false,
        subTableData: [{
            num: '2',
            warehouse: '樱花仓',
            quoteItem: '',
            priceUnit: '',
            flowRate: '',
            remark: '',
            formula: '',
            volume: '',
            totalPrice: '',
            price: '',
            checked: false
        },
        {
            num: '3',
            warehouse: '樱花仓',
            quoteItem: '',
            priceUnit: '',
            flowRate: '',
            remark: '',
            formula: '',
            volume: '',
            totalPrice: '',
            price: '',
            checked: false
        }]
    },
    {
        num: '4',
        warehouse: '工业园仓',
        quoteItem: '',
        priceUnit: '',
        flowRate: '',
        remark: '',
        formula: '',
        volume: '1661078.41',
        totalPrice: '',
        price: '',
        showSubTable: true,
        checked: false,
        subTableData: [{
            num: '5',
            warehouse: '工业园仓',
            quoteItem: '立体管理费',
            priceUnit: '元/m3',
            flowRate: '100000',
            remark: '包含库存管理和下',
            formula: '',
            volume: '373128',
            totalPrice: '',
            price: '',
            checked: false
        }]
    },
    {
        num: '6',
        warehouse: '樱花仓',
        quoteItem: '',
        priceUnit: '',
        flowRate: '',
        remark: '',
        formula: '',
        volume: '3632793.91',
        totalPrice: '',
        price: '',
        showSubTable: true,
        subTableData: [],
        checked: false
    },
    {
        num: '7',
        warehouse: '樱花仓',
        quoteItem: '',
        priceUnit: '',
        flowRate: '',
        remark: '',
        formula: '',
        volume: '3632793.91',
        totalPrice: '',
        price: '',
        showSubTable: true,
        checked: false,
        subTableData: [{
            num: '8',
            warehouse: '樱花仓',
            quoteItem: '',
            priceUnit: '',
            flowRate: '',
            remark: '',
            formula: '',
            volume: '3632793.91',
            totalPrice: '',
            price: '',
            checked: false
        }]
    }
];
export default tableData;